import React from 'react';
import { Link } from 'react-router-dom';
import 'whatwg-fetch';

export default class MyNavMenuDynamic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: 'not connected',
    };
  }

  render() {
    return (
      <Link to={this.props.route + this.props.match.params.id}>
        <h6 className={'navMenuTitle '}>{this.props.label}</h6>
      </Link>
    );
  }
}
